import { observable, action } from 'mobx';
import { WeaTools } from 'ecCom';
import * as API from '../apis/card';
import isEmpty from 'lodash/isEmpty';
import {WeaForm} from 'comsMobx';
import cloneDeep from 'lodash/cloneDeep'
import { message } from 'antd';
import forEach from 'lodash/forEach';
import {i18n} from '../public/i18n';

export class HrmPersonal {
  @observable hrmId = ''
  @observable conditions = []
  @observable tableInfo = []
  @observable tabInfo = []
  @observable isEditor = false
  @observable buttons = {}
  @observable loading = false
  @observable tabkey = '0'
  @observable form = new WeaForm();
  @observable date;
  personalEditTables;

  @action
  edit() {
    this.isEditor = true;
    this.getData();
    this.getTabInfo();
    this.tabkey = '0';
  }

  save() {
    let pDatas = this.form.getFormParams();
    let flag = false;
    this.form.validateForm().then(f => {
      if (f.isValid) {
        if(this.personalEditTables){
          if(this.personalEditTables.refs.edit.doRequiredCheck().pass){
            this.tableInfo && this.tableInfo.forEach(t=>{
              t.tabinfo.datas = t.tabinfo.datas || [];
              pDatas[t.tabinfo.rownum] = t.tabinfo.datas.length;
              t.tabinfo && t.tabinfo.datas && t.tabinfo.datas.forEach((item, index) =>{
                  !isEmpty(item) && forEach(item, (value, key)=> {
                      pDatas[`${key}_${index}`] = value;
                  })
              })
            })
            API.editResource({...{operation:'editpersonalinfo', id: this.hrmId}, ...pDatas}).
            then(data=>{
              if (data.status == '1') {
                  message.success(i18n.message.saveSuccess());
                  this.init();
                  this.getData();
              } else {
                  message.warning(data.message);
              }
            }, error=> {
                message.warning(error.message);
            })
          }
        }else{
          API.editResource({...{operation:'editpersonalinfo', id: this.hrmId}, ...pDatas}).
            then(data=>{
              if (data.status == '1') {
                  message.success(i18n.message.saveSuccess());
                  this.init();
                  this.getData();
              } else {
                  message.warning(data.message);
              }
            }, error=> {
                message.warning(error.message);
          })
        }
      } else {
        f.showErrors();
        this.setDate(new Date());
      }
    })
  }

  changeTab(key) {
    this.tabkey = key;
  }

  init() {
    this.tabkey = '0';
    this.isEditor = false;
    this.form = new WeaForm();
  }

  updateTableInfo(data) {
    this.tableInfo = data
  }

  updateTabkey(key) {
    this.tabkey = key;
  }

  getTabInfo(){
    this.tabInfo = [];
    this.tableInfo && this.tableInfo.forEach((c, idx)=>{
      if(!c.hide){
        this.tabInfo.push({
          key: `${idx}`,
          title: c.tabname,
        })
      }
    })
    if(!isEmpty(this.tabInfo)) this.tabkey = this.tabInfo[0].key;
  }

  getData(params={}) {
    this.loading = true;
    params.id=this.hrmId;
    params.viewAttr=this.isEditor?2:1;
    params.is_multilang_set=this.isEditor;
    params.operation = 'getResourcePesonalView';
    API.getResourceCard(params).then((data) => {
      this.loading = false;
      this.form.initFormFields(data.result.conditions);
      this.conditions = data.result.conditions;
      this.tableInfo = data.result.tables;
      this.getTabInfo();
      this.buttons = data.result.buttons;
      this.hrmId = data.result.id;
    })
  }

  setPersonalEditTables(ref){
    this.personalEditTables = ref;
  }
  
  setDate(date) {
    this.date = date;
  }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/stores/personal.js